<template>
  <div>
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <template></template>
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <b-row class="mt-4">
              <div
                class="form-group col-md-2"
                :data-deferred="toLocaleCurrency()"
              >
                <ValidationProvider
                  vid="gross_ext"
                  name="Da incassare"
                  :rules="{
                    required: true,
                    between_number: {
                      min: '0',
                      max: amountToCollect,
                      label: `L'importo da recuperare`,
                    },
                  }"
                  v-slot="{ errors, validate, dirty, valid }"
                >
                  <div
                    :class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && !valid,
                    }"
                  >
                    <base-currency
                      name="amount_titolo_lisapay"
                      vid="gross"
                      label="Importo da incassare"
                      v-model="form.insurance_ancillary.amount"
                      :options="{ currency: 'EUR', locale: 'it-IT' }"
                      :rules="{}"
                      @input="(val) => validate(val)"
                    />
                  </div>
                  <small
                    class="text-danger"
                    style="display: block; margin-top: -1rem"
                  >{{ errors[0] }}</small
                  >
                </ValidationProvider>
              </div>
            </b-row>
            <b-row class="py-2 mb-4">
              <div class="col-md-2">
                <div class="lisapay-button-wrapper" style="max-width: 100%">
                  <button
                    class="lisapay-button"
                    data-type="simple"
                    @click="handleSubmit(onSubmit)"
                    :disabled="invalid"
                  >
                    <span class="sr-only">Paga con Lisapay</span>
                  </button>
                </div>
              </div>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
// import BaseIcon from "@/components/BaseIcon";
import BaseCurrency from "@/components/form/BaseCurrency";
import {toLocaleCurrency} from "@/utils/strings";
import {toLocaleDate} from "@/utils/dates";
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import {RepositoryFactory} from "@/repositories/RepositoryFactory";
import {mapGetters} from "vuex";
import client from "@/repositories/api";

export default {
  mixins: [ShowMixin, FormMixin],
  name: "CollectLisapay",
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: true,
      lisapayPopup: null,
      detail: null,
      repository: "lisapay_proceed",
      args: {},
      codeAgency: (/(?:www.)?(\w+)(\..*)+/.exec(window.location.hostname) || [
        null,
        window.location.hostname,
      ])[1],
      form: {
        insurance_ancillary: {
          amount: null,
        },
      },
    };
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    onSubmit() {
      if (!this.isLisapayConfigured) {
        this.$showSnackbar({
          preset: "error",
          text: "Configurazione Lisapay non disponibile.",
        });
        return;
      }
      const payload = {
        type: "insurance_ancillary",
        amount: this.form.insurance_ancillary.amount,
        id: this.dbRowData.id,
      };
      const Repo = RepositoryFactory.get(this.repository);
      Repo.create(payload)
        .then((response) => {
          console.log("response", response);
          if (response?.data?.data) {
            const data = response.data.data;
            this.$showSnackbar({
              preset: "success",
              text: `Titolo inviato a Lisapay`,
            });

            this.payWithLisaPayCollectInsAnc(
              this.dbRowData,
              data.id,
              data.external_id,
            );
          }
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    lisapayAddress(registry) {
      if (!registry) return "";
      const c = registry?.correspondences?.[0];
      return c
        ? [
          c.attributables?.ADDR,
          [c.attributables?.ZIP, c.geo_location?.COUNCIL]
            .filter(Boolean)
            .join(" "),
          c.geo_location?.PRVCODE && `(${c.geo_location.PRVCODE})`,
        ]
          .filter(Boolean)
          .join(", ")
        : "";
    },
    payWithLisaPayCollectInsAnc(item, lisapay_id, external_id) {
      console.log("external_id", external_id);

      const pre_collect = `https://${
        this.lisapayConfig.callback_base_url
      }/v2/pre-collect/${this.codeAgency.toLowerCase()}/${lisapay_id}`;
      const post_collect = `https://${
        this.lisapayConfig.callback_base_url
      }/v2/post-collect/${this.codeAgency.toLowerCase()}/${lisapay_id}`;

      let str = "";

      if (item.code.value === "P") {
        str = `Polizza ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      } else if (item.code.value === "Q") {
        str = `Quietanza ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      } else if (item.code.value === "A") {
        str = `Appendice ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      }

      const url = `https://${this.lisapayConfig.base_url}/api/v1/carts/add-item`;

      const branch =
        item.insurance_policy.insurance_risk.risk_branch.risk_type.code;

      const bodyRequest = {
        code: `LW3-${this.codeAgency.toUpperCase()}-${
          item.insurance_policy.insurer.code
        }-${branch}`,
        branch: branch,
        amount: Number.parseFloat(this.form.insurance_ancillary.amount).toFixed(
          2,
        ),
        annual_amount: Number.parseFloat(
          this.form.insurance_ancillary.amount,
        ).toFixed(2),
        description: str,
        platform: "Lisaweb 3.0",
        reason: `${item.insurance_policy.insurer.code} ${item.insurance_policy.number}`,
        reference: item.insurance_policy?.registry?.title,
        precall_url: pre_collect,
        callback_url: post_collect,
        callback_method: "POST",
        external_id: external_id,
        fiscal_code: item.insurance_policy?.registry?.attributables?.NINO,
        email:
        item.insurance_policy?.registry?.address_books?.[0]?.attributables
          ?.MAIL,
        residence_address: this.lisapayAddress(item.insurance_policy?.registry),
      };

      client
        .put(url, bodyRequest, {
          headers: {
            lwAgency: this.codeAgency,
            lwRealm: this.lisapayConfig.realm,
            lwToken: this.$store.state.auth.token,
          },
        })

        .then((response) => {
          console.log("response", response);
          // se popup_already_opened è false, chiamare il window.open e la rotta è: /cart/:id che è quello che mi è arrivato

          if (!response.data.popup_already_opened) {
            const windowFeatures = "popup=1,left=10,width=1000,height=1000";

            this.lisapayPopup = window.open(
              `https://${this.lisapayConfig.base_url}/cart/${response.data.id}?lwAgency=${this.codeAgency}&lwRealm=${this.lisapayConfig.realm}&lwToken=${this.$store.state.auth.token}`,
              "Lisapay",
              windowFeatures,
            );
          } else {
            if (this.lisapayPopup && !this.lisapayPopup.closed) {
              this.lisapayPopup.focus();
            }
          }
        })
        .catch((error) => {
          let errMsg;
          switch (error.status) {
            case 422: // Unprocessable Content
              errMsg =
                "C'è stato un errore, ti preghiamo di ricontrollare i dati inseriti.";
              break;
            default:
              errMsg =
                "C'è stato un errore, ti preghiamo di riprovare più tardi. Se il problema persiste, ti invitiamo a contattare l'assistenza.";
          }
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
    }),
  },
  components: {
    // BaseIcon,
    BaseCurrency,
  },
  computed: {
    ...mapGetters("auth", ["lisapayConfig", "isLisapayConfigured"]),
  },
  beforeMount() {
    const Repo = RepositoryFactory.get("insurance_ancillary");
    Repo.remaining_balance(this.resourceId)
      .then((response) => {
        this.amountToCollect = response?.data?.amount;
        this.form.insurance_ancillary.amount = response?.data?.amount;
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({preset: "error", text: errMsg});
        this.isLoading = false;
      });
  },
};
</script>
<style>
.is-valid .form-control {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem);
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E");
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.is-invalid .form-control {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E");
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.lisapay-button-wrapper {
  width: 100%;
  max-width: 200px;
  height: 40px;
  margin: 0 0 0 auto;
}

.lisapay-button {
  display: block;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 8px;
  border: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
  0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: var(--radius-sm);
  min-width: 90px;
}

.lisapay-button[disabled] {
  opacity: 0.5;
  filter: grayscale(0.5);
  cursor: default;
}

.lisapay-button[data-type="simple"] {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 934.7 266.5'%3E%3Cpath d='M337.8,66.2c-2.7-2.7-6.4-4-10.2-3.8c-3.8-0.2-7.5,1.1-10.2,3.8c-2.4,3.2-3.6,7.2-3.3,11.2v110.1 c-0.3,4,0.8,8,3.3,11.2c2.7,2.6,6.4,4,10.2,3.8c3.7,0.2,7.4-1.2,10-3.8c2.6-3.2,3.8-7.2,3.5-11.2v-110 C341.5,73.5,340.3,69.4,337.8,66.2z' fill='%2323469D'/%3E%3Cpath d='M379.5,62.4c-3.8,0-7.4,1.6-10,4.3c-2.8,2.6-4.3,6.2-4.3,10s1.6,7.3,4.3,9.8c2.6,2.8,6.2,4.3,10,4.3h0.6 c7.8-0.2,14.1-6.7,13.9-14.5S387.3,62.2,379.5,62.4z' fill='%2323469D'/%3E%3Cpath d='M494.8,150c-7.9-5.8-17.2-9.6-26.9-11l-8.4-1.8c-5.5-1-10.8-2.6-15.8-4.8c-2.1-1.1-3.5-3.3-3.5-5.7 c-0.1-2.9,1.4-5.6,3.8-7.1c3.5-1.7,7.4-2.5,11.3-2.3c2.4,0,4.9,0.4,7.2,1.1c2.2,0.5,4.3,1.5,6.1,2.8l2.1,1.6 c3.4,3.3,7.9,5.4,12.6,6.2c3,0.1,5.9-1,8.1-3.1c2.2-1.9,3.4-4.8,3.3-7.7c-0.5-6.8-4.9-12.8-11.3-15.4c-8.6-4.5-18.2-6.7-27.9-6.4 c-10.8-0.6-21.5,2.6-30.2,9c-7.4,6-11.5,15-11.2,24.5c-0.4,7.2,2.5,14.1,7.9,18.9c8,5.9,17.3,9.9,27.1,11.5l0,0l10.1,2.8 c0.1,0.2,0.3,0.2,0.5,0.2c10.3,2.6,15.6,5.9,15.6,10.2c0.1,3.1-1.6,5.9-4.3,7.4c-3.8,1.9-8,2.9-12.3,2.6c-3.6,0.1-7.3-0.4-10.7-1.5 c-2.8-1-5.3-2.7-7.4-4.8l-2.6-3c-3-3.9-7.4-6.4-12.2-6.9h-0.7c-6.5,0.2-11.6,5.7-11.4,12.2c0.4,7.6,4.9,14.3,11.8,17.6 c9,5.1,19.3,7.6,29.7,7.2c12.3,0.8,24.6-2.4,35.1-9c8.2-6.1,12.8-15.9,12.2-26.1C503,162,500.1,154.9,494.8,150z' fill='%2323469D'/%3E%3Cpath d='M389.7,102.1c-2.7-2.7-6.4-4-10.2-3.8c-3.8-0.3-7.6,1.1-10.2,3.8c-2.4,3.2-3.6,7.3-3.3,11.3v74.2 c-0.3,4,0.8,8,3.3,11.2c2.7,2.6,6.4,4,10.2,3.8c3.7,0.2,7.4-1.2,10-3.8c2.6-3.2,3.8-7.2,3.5-11.2v-74.2 C393.3,109.4,392.1,105.4,389.7,102.1z' fill='%2323469D'/%3E%3Cpath d='M603.8,185.8v-60.9h0c0.4-8.7-3.9-16.8-11.1-21.2c-9.9-5.4-21.2-7.9-32.4-7.2c-10.1-0.3-20,2.3-28.6,7.6 c-6.7,3.4-11.2,10.1-11.7,17.6c-0.1,3,1,5.8,3.1,7.9c2,2.1,4.8,3.2,7.7,3.1c4.8-0.5,9.1-3,12-6.9l3.1-3.1c1.9-1.8,4.2-3,6.7-3.8 c1.3-0.5,2.7-0.8,4.1-1s2.9-0.3,4.4-0.3c4.3-0.4,8.7,0.5,12.6,2.6c2.7,2,4.1,5.3,3.8,8.7c0,1.7-0.3,3.4-1,4.9c-0.8,1.4-2,2.5-3.5,3 c-4.1,1.1-8.3,1.8-12.6,2.1c-6.9,0.8-11.9,1.6-15.4,2.3c-8.6,1.1-16.6,4.9-23,10.8c-4.8,6.1-7.2,13.7-6.7,21.4 c-0.5,8.5,2.4,16.9,8.1,23.2c6,5.7,14.2,8.7,22.5,8.2c6.6,0.1,13.2-1.4,19.2-4.3c5.4-2.8,10-6.9,13.3-12c-0.4,4.4,0.9,8.7,3.6,12.2 c3,2.8,7.1,4.2,11.2,3.9c3.1,0.2,6.1-0.8,8.5-2.8c2.1-2,3.2-4.7,3.1-7.6l-0.5-4.9C604,188.1,603.9,187,603.8,185.8z M571.8,177.7 c-4.4,4.2-10.3,6.5-16.4,6.2c-3.8,0.2-7.5-1-10.4-3.3c-2.6-2.3-3.9-5.5-3.8-8.9c-0.1-3.1,0.9-6.1,2.8-8.4c2.8-2.5,6.2-4.3,9.9-5.1 c3-0.8,5.9-1.5,8.9-2c5.3-1.1,10.4-2.8,15.3-4.9l-0.1,9.6C578.3,167.1,576.1,173.2,571.8,177.7z' fill='%2323469D'/%3E%3Cpath d='M826.1,185.8v-60.9h0c0.4-8.7-3.9-16.8-11.1-21.2c-9.9-5.4-21.2-7.9-32.4-7.2c-10.1-0.3-20,2.3-28.6,7.6 c-6.7,3.4-11.2,10.1-11.7,17.6c-0.1,3,1,5.8,3.1,7.9c2,2.1,4.8,3.2,7.7,3.1c4.8-0.5,9.1-3,12-6.9l3.1-3.1c1.9-1.8,4.2-3,6.7-3.8 c1.3-0.5,2.7-0.8,4.1-1s2.9-0.3,4.4-0.3c4.3-0.4,8.7,0.5,12.6,2.6c2.7,2,4.1,5.3,3.8,8.7c0,1.7-0.3,3.4-1,4.9c-0.8,1.4-2,2.5-3.5,3 c-4.1,1.1-8.3,1.8-12.6,2.1c-6.9,0.8-11.9,1.6-15.4,2.3c-8.6,1.1-16.6,4.9-23,10.8c-4.8,6.1-7.2,13.7-6.7,21.4 c-0.5,8.5,2.4,16.9,8.1,23.2c6,5.7,14.2,8.7,22.5,8.2c6.6,0.1,13.2-1.4,19.2-4.3c5.4-2.8,10-6.9,13.3-12c-0.4,4.4,0.9,8.7,3.6,12.2 c3,2.8,7.1,4.2,11.2,3.9c3.1,0.2,6.1-0.8,8.5-2.8c2.1-2,3.2-4.7,3.1-7.6l-0.5-4.9C826.3,188.1,826.2,187,826.1,185.8z M794.1,177.7 c-4.4,4.2-10.3,6.5-16.4,6.2c-3.8,0.2-7.5-1-10.4-3.3c-2.6-2.3-3.9-5.5-3.8-8.9c-0.1-3.1,0.9-6.1,2.8-8.4c2.8-2.5,6.2-4.3,9.9-5.1 c3-0.8,5.9-1.5,8.9-2c5.3-1.1,10.4-2.8,15.3-4.9l-0.1,9.6C800.6,167.1,798.4,173.2,794.1,177.7z' fill='%2323469D'/%3E%3Cpath d='M133.2,0C59.7,0,0,59.7,0,133.2s59.7,133.2,133.2,133.2s133.2-59.7,133.2-133.2S206.8,0,133.2,0z M186.1,208.7 C186.1,208.7,186.1,208.7,186.1,208.7L186.1,208.7l-91.9,0c-12.2,0-22.2-9.9-22.2-22.1c0,0,0-0.1,0-0.1V70.2C72,57.9,82,48,94.2,48 c12.2,0,22.2,9.9,22.2,22.1c0,0,0,0.1,0,0.1v94.1h69.7c12.3,0,22.2,9.9,22.2,22.2C208.3,198.7,198.4,208.7,186.1,208.7z' fill='%2323469D'/%3E%3Cpath d='M926.4,99.5c-6-2.5-13-1.2-16.6,4.5c-1.2,2-2.1,3.9-2.6,5.7l-17.3,64.2l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.3-0.2-0.5l-17.7-63.9c-0.5-1.9-1-3.2-1.6-4.2c-6.8-11.8-26.7-7.9-26.3,6.7c0,1.4,0.4,3.3,1.2,5.8l3,9l28,79.8 c0.2,0.4,0.2,0.8,0.1,1.2c-0.7,3.1-2,6.2-5,7.6c-1.9,0.9-5,0.8-7.3,0.8c-4.5-0.1-10,1.6-11.9,6.2c-1.9,4.6-1.1,10,2.7,13.4h0 c4.1,3.7,10.1,4.5,15.3,4.4c14.8-0.4,22.3-9,27.6-21.9c1.4-3.6,2.8-7.2,4.1-10.8l29.6-83.9c1.3-3.9,3.1-8,3.4-11.6 C935,106.6,931.2,101.5,926.4,99.5z' fill='%2323469D'/%3E%3Cpath d='M710.9,112.8c-7.1-9.5-18.4-14.9-30.2-14.6c-5.9-0.2-11.7,1.2-16.9,4.1c-5.3,3.3-9.8,7.7-13,13l-0.1-3.2 c0.1-3.3-1-6.6-3.3-9c-2.5-2.3-5.8-3.5-9.2-3.3c-3.7-0.2-7.4,1.2-10,3.8c-2.4,3.2-3.6,7.2-3.3,11.2V225c-0.3,4,0.9,8,3.3,11.3 c5.6,5,14.1,5,19.7,0c2.4-3.2,3.6-7.3,3.3-11.3v-35.1c3.1,5.1,7.5,9.2,12.7,12c5.3,2.6,11.2,4,17.1,3.9c11.8,0.1,23-5.5,29.9-15.1 c8.2-11.4,12.3-25.1,11.7-39.1C723.2,137.7,719.1,124,710.9,112.8z M689.8,174.5c-3.6,5.2-9.6,8.2-15.9,8 c-6.6,0.3-12.9-2.7-16.8-8.1c-7.7-14.1-7.7-31.2,0-45.3c3.9-5.2,10.1-8,16.6-7.7c6.5-0.3,12.7,2.8,16.3,8.1c4.2,7,6.3,15.1,5.7,23.2 C696.1,160.4,694.1,168,689.8,174.5z' fill='%2323469D'/%3E%3C/svg%3E") #fff center center no-repeat;
  background-origin: content-box;
}
</style>